class HomeLinks {

	static getHomeLinks(app) {
		var homelinks = [];

		const appconfig = app.getConfig();
		const routesconfig = (appconfig.routes ? appconfig.routes : {});
		const hasquotes = (routesconfig.quotes && (routesconfig.quotes.disabled === true) ? false : true);
		const hasbounties = (routesconfig.bounties && (routesconfig.bounties.disabled === true) ? false : true);
		const hasdeeds = (routesconfig.deeds && (routesconfig.deeds.disabled === true) ? false : true);

		if (hasquotes) {
			homelinks.push({type:'link', pathname: '/quote', label: 'Create a quote'});
			homelinks.push({type:'link', pathname: '/quotes', label: 'Quotes'});

			if ((hasbounties !== true) && (hasdeeds != true)) {
				homelinks.push({type:'link', pathname: '/orders', label: 'Orders'});
				homelinks.push({type:'link', pathname: '/invoices', label: 'Invoices'});
				homelinks.push({type:'link', pathname: '/paymentnotices', label: 'Payment Notices'});
			}
		}

		if (hasquotes && hasbounties)
		homelinks.push({type:'separator'});

		if (hasbounties) {
			homelinks.push({type:'link', pathname: '/bounty', label: 'Create a bounty'});
			homelinks.push({type:'link', pathname: '/bounties', label: 'Bounties'});
		}

		if ((hasbounties && hasdeeds) || (hasquotes && hasdeeds))
		homelinks.push({type:'separator'});

		if (hasdeeds) {
			homelinks.push({type:'link', pathname: '/deed', label: 'Create a deed'});
			homelinks.push({type:'link', pathname: '/deeds', label: 'Deeds'});
		}

		return homelinks;
	}
}

export default HomeLinks;